export default "__VITE_ASSET__F32yiE9V__"